import { useState, useEffect } from "react";
import { useParams, NavLink, useHistory } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";

import Sidebar from "../../../components/consolecomponents/sidebar/Sidebar";
import AppCard from "../../../components/consolecomponents/card/AppCard";
import NewAppModal from "../../../components/consolecomponents/modal/NewAppModal/index";
import FormikControl from "../../../util/formcomponents/FormikControl";

import styles from "./Project.module.scss";
import arrowdown from "../../../Assets/arrowdown.svg";
import arrowup from "../../../Assets/arrowup.svg";
import plus from "../../../Assets/plus.svg";

import overview from "../../../Assets/applifecycle/overview.svg";
import services from "../../../Assets/applifecycle/services.svg";
import info from "../../../Assets/info.svg";
import pending from "../../../Assets/pending.svg";
import exclamationcircle from "../../../Assets/exclamationcircle.svg";

import { Field, Form, Formik } from "formik";
import { CustomToast } from "../../../util/custom-toast/CustomToast";
import ComingSoonModal from "../../../components/consolecomponents/modal/ComingSoonModal";
import IsLoading from "../../../util/loader/IsLoading";
import {
  useAllProjects,
  useOneProject,
  useProjectAppCount,
} from "../../../hooks/DevProjectHooks";
import {
  useAllApps,
  useAppConfig,
  useGetCategoryList,
} from "../../../hooks/DevAppHooks";
import { Tooltip } from "@material-ui/core";
import { useQueryClient } from "react-query";
import { projectStatus } from "../../../util/helpers/statusHelper";
import DEAModal from "../../../components/consolecomponents/modal/DEAModal";
import exclamationcircleblue from "../../../Assets/exclamationcircleblue.svg";
import { getFTUData, getProjAppCount } from "../../../util/helpers/funcHelper";
import CustomModal from "../../../components/modal";
import FTUGuide from "../../../components/globalComponents/ftu-guide";
import ConsoleLocalStorage from "../../../storage/storage";

const appType = [
  {
    key: "Build an application from scratch",
    value: "Build an application from scratch",
  },
  {
    key: "Port my existing AR/VR Application on JioGlass",
    value: "Port my existing AR/VR Application on JioGlass",
  },
];

const engineOptions = [
  { key: "Unity", value: "Unity" },
  { key: "Unreal", value: "Unreal" },
];
const platformOptions = [
  { key: "Oculus Go", value: "Oculus Go" },
  { key: "Oculus Quest", value: "Oculus Quest" },
  { key: "HTC Vive", value: "HTC Vive" },
  { key: "Magic leap", value: "Magic leap" },
  { key: "Microsoft Hololens", value: "Microsoft Hololens" },
  { key: "Google Daydream", value: "Google Daydream" },
  { key: "Nreal", value: "Nreal" },
  { key: "PS VR", value: "PS VR" },
  {
    key: "Mobile AR (AR Core/ AR Kit)",
    value: "Mobile AR (AR Core/ AR Kit)",
  },
  { key: "Samsung Gear VR", value: "Samsung Gear VR" },
  { key: "Other", value: "" },
];
const developerKitOptions = [
  { key: "2", value: "2" },
  { key: "4", value: "4" },
  { key: "6", value: "6" },
  { key: "Other", value: "" },
];

const Project = () => {
  const [showProject, setShowProject] = useState(false);
  const [showApp, setShowApp] = useState(false);
  const [showNewAppModal, setShowNewAppModal] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [projectKey, setProjectkey] = useState("KEYNEKEF132DSEFAF");
  const [currentOs, setCurrentOs] = useState("android");
  const [viewDetails, setViewDetails] = useState(true);
  const { projectid } = useParams();
  const { data: categoryOptions } = useGetCategoryList("project");
  const history = useHistory();
  const [showDEA, setShowDEA] = useState(false);
  const [sidebarProjectId, setSideBarProjectId] = useState("");
  const queryClient = useQueryClient();

  const [showFTU, setShowFTU] = useState(false);
  const [ftuData, setFtuData] = useState(getFTUData("all"));
  const [showDropdown, setShowDropdown] = useState(false);

  const organization =
    localStorage.getItem("organization") &&
    JSON.parse(localStorage.getItem("organization"));

  const {
    data: project,
    isLoading: oneLoading,
    isError: oneError,
  } = useOneProject(projectid, setViewDetails);
  const {
    mutate: getProjectAppCount,
    data: appCountData,
    isLoading: appCountLoad,
    isError: appCountError,
  } = useProjectAppCount(projectid, project?.status, currentOs);
  const {
    data: projects,
    isLoading: allLoading,
    isError: allError,
  } = useAllProjects();

  const { data: configData } = useAppConfig(
    ConsoleLocalStorage.getOrganization().tags
  );

  /** whenever app create pressed then check if more apps allowed then open modal else throw err */
  const openAppModal = async () => {
    let { apps } = await getProjAppCount(
      ConsoleLocalStorage.getOrganization().id
    );
    if (apps.used >= apps.allowed) {
      CustomToast(
        `You\'ve reached the limit of Apps for your license. Please upgrade your license to add more.`
      );
    } else {
      setShowNewAppModal(true);
    }
  };

  useEffect(() => {
    console.log(configData);
  }, [configData]);

  const [appPlatform, setAppPlatform] = useState({
    platformName: "All Apps",
    selectedPlatformCount: 0,
    platformType: "ALL",
    platformColor: "",
  });

  useEffect(() => {
    let count = 0;
    if (appCountData && appPlatform.platformType != "ALL") {
      count = appCountData.find((x) => x.platform === appPlatform.platformType);
    }

    setAppPlatform({
      ...appPlatform,
      selectedPlatformCount: count
        ? count.count
        : appCountData && appCountData[0].count,
    });
  }, [appCountData]);

  const {
    mutate: getAllApps,
    data: apps,
    isLoading: appsLoading,
    isError: appsError,
  } = useAllApps(
    projectid,
    appPlatform.platformType,
    project?.status,
    currentOs
  );

  useEffect(() => {
    console.log(currentOs, "currentOscurrentOscurrentOscurrentOscurrentOs");
    getProjectAppCount();
    getAllApps();
  }, [currentOs, appPlatform.platformType]);

  if (project?.status === projectStatus?.rejected?.status) {
    history.push("/console");
  }
  /**
   * Rendering after fetching
   */
  if (oneLoading || allLoading || appsLoading) {
    return <IsLoading />;
  }

  return (
    <>
      <DEAModal
        showDEA={showDEA}
        projectid={sidebarProjectId}
        setShowDEA={setShowDEA}
      />
      <NewAppModal
        showNewAppModal={showNewAppModal}
        setShowNewAppModal={setShowNewAppModal}
        projectid={projectid}
        configData={configData}
      />
      <ComingSoonModal
        showComingSoon={showComingSoon}
        setShowComingSoon={setShowComingSoon}
      />
      <CustomModal
        showModal={showFTU}
        setShowModal={setShowFTU}
        isDismissible={false}
        size="lg"
        rootClassName={"carousal"}
      >
        <FTUGuide
          showModal={showFTU}
          setShowModal={setShowFTU}
          data={ftuData}
        />
      </CustomModal>
      <div className={styles.container}>
        <Sidebar>
          <section className="sidebar_app">
            <div
              onClick={() => setShowProject(!showProject)}
              className="sidebar_projects"
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3
                  onClick={() =>
                    showProject ? history.push("/console/") : null
                  }
                  className={`${showProject ? "inactive" : ""}`}
                >
                  {showProject
                    ? `All Projects (${projects?.length})`
                    : project?.name}
                </h3>
                <img
                  src={arrowdown}
                  alt="logo"
                  className="mr-1 fluid logo"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    marginLeft: "0.25rem",
                  }}
                />
              </div>
              {showProject ? (
                <ul className="sidebar_projectlist">
                  {projects.map((project) =>
                    project.status == projectStatus.draft.status ||
                    project.status == projectStatus.rejected.status ? (
                      <li key={project?.id}>
                        <a
                          onClick={() => {
                            setSideBarProjectId(project.id);
                            setShowDEA(true);
                          }}
                        >
                          <span className="sidebar_list_items">
                            {project?.name}
                          </span>
                        </a>
                      </li>
                    ) : (
                      <li key={project?.id}>
                        <NavLink
                          to={`/console/${project.id}`}
                          onClick={() =>
                            queryClient.invalidateQueries("allapps", {
                              exact: true,
                            })
                          }
                        >
                          <span className="sidebar_list_items">
                            {project?.name}
                          </span>
                        </NavLink>
                      </li>
                    )
                  )}
                </ul>
              ) : null}
            </div>
          </section>
          <section className="sidebar_app">
            <div
              onClick={() => setShowApp(!showApp)}
              className="sidebar_projects"
            >
              <h3 className="">
                Apps
                <img
                  src={arrowdown}
                  alt="logo"
                  className="mr-1 fluid logo"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    marginLeft: "0.25rem",
                  }}
                />
              </h3>

              {apps && showApp ? (
                <ul className="sidebar_projectlist">
                  {apps?.map((app) => (
                    <li key={app.id}>
                      <NavLink to={`/console/${project.id}/${app.id}`}>
                        <span className="sidebar_list_items">{app.title}</span>{" "}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </section>
          <section className="panel_tertiary_container">
            <ul className="sidebar_list_secondary">
              <li className="">
                <NavLink
                  exact
                  activeClassName="active"
                  to={`/console/${project.id}`}
                >
                  <img src={overview} alt="logo" className="sidebar_card_img" />
                  Project Overview
                </NavLink>
              </li>
              {/* <li onClick={() => setShowComingSoon(true)} className="">
                <a href="#">
                  <img
                    src={analytics}
                    alt="logo"
                    className="sidebar_card_img"
                  />
                  Analytics
                </a>
              </li> */}
              <li onClick={() => setShowComingSoon(true)} className="">
                <a href="#">
                  <img src={services} alt="logo" className="sidebar_card_img" />
                  Services
                </a>
              </li>
            </ul>
          </section>
        </Sidebar>
        <div className={styles.main}>
          {/**
           * Breadcrumb
           */}
          <div className="d-flex d-justify-sb">
            <div>
              <Breadcrumb bsPrefix="breadcrumb">
                <Breadcrumb.Item
                  href=""
                  onClick={() => history.push("/console")}
                >
                  <span className="breadcrumb_item">Dashboard</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                  <span className="breadcrumb_item active">
                    {project?.name}
                  </span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <div className="howtoguide">
              <span
                className="text-dark-sky-blue c-pointer"
                onClick={() => {
                  setFtuData(getFTUData("app"));
                  setShowFTU(true);
                }}
              >
                How to get started?
                <img
                  src={exclamationcircleblue}
                  alt="logo"
                  className="mr-1 fluid logo"
                  style={{
                    width: "1rem",
                    height: "1rem",
                    marginLeft: "0.25rem",
                  }}
                />
              </span>
            </div>
          </div>

          {/**
           * Main body
           */}
          {viewDetails ? (
            /**
             * * Approval pending
             */
            <div className={styles.previewbody}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "0.5em",
                }}
                className=""
              >
                <h3
                  className={styles.headingpreview}
                  onClick={() => setViewDetails(project.status !== 1)}
                >
                  {project.name}
                </h3>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    // border: "1px solid white",
                  }}
                  className=""
                >
                  {/* {project.status === 0 ? (
                    project.deaUrl ? (
                      <img
                        src={pending}
                        alt="logo"
                        style={{ marginRight: "0.5em" }}
                        className="console_card_img"
                      />
                    ) : (
                      <img
                        src={exclamationcircle}
                        alt="logo"
                        style={{ marginRight: "0.5em" }}
                        className="console_card_img"
                      />
                    )
                  ) : null} */}
                  {project.status !== projectStatus?.approved.status && (
                    <img
                      src={
                        project.status === projectStatus.draft.status ||
                        project.status === projectStatus.rejected.status
                          ? exclamationcircle
                          : pending
                      }
                      alt="logo"
                      style={{ marginRight: "0.5em" }}
                      className="console_card_img"
                    />
                  )}
                  <span
                    style={{
                      fontFamily: "JioType-Medium",
                      fontSize: "12px",
                      color: `${project.status === 1 ? "#42be7b" : "#fb5050"}`,
                    }}
                  >
                    {project.status === projectStatus.approved.status
                      ? "Approved"
                      : project.status === projectStatus.pending.status
                      ? "Approval Pending"
                      : "Upload DEA File"}
                  </span>
                </div>
              </div>

              <Formik initialValues={project} enableReinitialize>
                {(formik) => {
                  // console.log(formik);
                  return (
                    <Form>
                      <div className={styles.formbody}>
                        <FormikControl
                          control="input"
                          type="text"
                          label="Project Name"
                          name="name"
                          disabled
                        />
                        <FormikControl
                          control="radio"
                          options={appType}
                          label="What would you like to do?"
                          disabled
                          name="appType"
                        />

                        <label className="xs-lable-select white" required>
                          Which Appstore category does your application belong
                          to?
                          <span style={{ color: "red" }}>{` *`}</span>
                        </label>
                        <div className="category_list">
                          {categoryOptions &&
                            categoryOptions.map((option) => {
                              return (
                                <div
                                  className="category_container"
                                  key={option.name}
                                >
                                  <div
                                    className={`category_box ${
                                      formik.values.category === option._id
                                        ? "category_box_active"
                                        : ""
                                    }`}
                                    style={{
                                      border: `${
                                        formik.values.category === option._id
                                          ? "1.5px solid #707070"
                                          : ""
                                      }`,
                                    }}
                                  >
                                    <img
                                      width="20px"
                                      src={option.devIcon}
                                      alt="category-icon"
                                    />
                                  </div>
                                  <span
                                    className={`category_title ${
                                      formik.values.category === option._id
                                        ? "category_title_active"
                                        : ""
                                    }`}
                                    style={{
                                      color: `${"#707070"}`,
                                    }}
                                  >
                                    {option.name}
                                  </span>
                                </div>
                              );
                            })}
                        </div>

                        {/**
                         * * PublisherName
                         */}

                        <div className="project_publisher_label_container">
                          <label
                            htmlFor={"publisherName"}
                            className="xs-lable-select white project_publisher_label"
                          >
                            Publisher's name
                          </label>
                          <Tooltip
                            title="To change your publisher's name contact admin"
                            arrow
                          >
                            <p className="publisher_i_btn">
                              <img
                                data-class="myTooltipClass"
                                src={info}
                                alt="category-icon"
                              />
                            </p>
                          </Tooltip>
                        </div>

                        <div className="primary_input">
                          <Field>
                            {({ field }) => {
                              return (
                                <input
                                  id={"publisherName"}
                                  name={"publisherName"}
                                  value={field.value.publisherName}
                                  style={{ color: "#646464" }}
                                  disabled
                                />
                              );
                            }}
                          </Field>
                        </div>

                        {/**
                         * * engine and platform
                         */}
                        {formik.values.appType ===
                        "Build an application from scratch" ? (
                          <FormikControl
                            control="checkbox"
                            name="engine"
                            options={engineOptions}
                            label="Which game engine do you develop on?"
                            disabled
                          />
                        ) : (
                          <FormikControl
                            control="checkbox"
                            options={platformOptions}
                            label="What platform is your application already published on?"
                            name="publishedPlatform"
                            disabled
                            present={platformOptions.map((opt) =>
                              opt.key !== "Other" ? opt.value : null
                            )}
                          />
                        )}

                        <FormikControl
                          control="textarea"
                          autoComplete="nope"
                          maxLen="990"
                          rows="5"
                          label="Describe your application concept:"
                          sublabel="Please mention your app/game concept, storyline, feature, target audience, development timelines."
                          name="appConcept"
                          disabled
                        />
                        <FormikControl
                          control="input"
                          required={false}
                          type="text"
                          label="Please insert reference media links to better describe your concept(APK links/demo video links)"
                          name="mediaLink"
                          disabled
                        />
                        <FormikControl
                          control="input"
                          required={false}
                          type="text"
                          label="How much time is estimated for a user to spend on your application daily?(In Minutes)"
                          name="dust"
                          disabled
                        />

                        {/**
                         * * Dates
                         * todo fix the calendar icon bug
                         */}
                        <FormikControl
                          control="date"
                          label="Please mention your estimated Alpha Release date"
                          name="alphaReleaseDate"
                          disabled
                        />
                        <FormikControl
                          control="date"
                          label="Please mention your estimated Beta Release date"
                          name="betaReleaseDate"
                          disabled
                        />
                        <FormikControl
                          control="date"
                          label="Please mention your estimated Production Release date"
                          name="prodReleaseDate"
                          disabled
                        />
                        <FormikControl
                          control="radio"
                          options={developerKitOptions}
                          label="How many developers would you need?"
                          name="developerKit"
                          present={["2", "4", "6"]}
                          disabled
                        />
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          ) : (
            /**
             * * Approved Project
             */
            <div className={styles.body}>
              <div className={styles.heading}>
                <div className="d-flex d-justify-center d-align-center">
                  <h3 className="">{project?.name}</h3>
                  <button onClick={() => setViewDetails(true)} className="">
                    View Details
                  </button>
                </div>

                <div
                  className={`${styles.dd_menu} mr-1 cursor-pointer fluid logo text-secondary nav_icon pointer`}
                >
                  <div
                    className={`${styles.appSpan} p_all-5 d-flex d-justify-sb`}
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    <span
                      className={`${styles.color_border} mlc-1 mtc-2`}
                      style={{
                        backgroundColor:
                          appPlatform.platformColor !== "#ffffff"
                            ? appPlatform.platformColor
                            : "",
                      }}
                    />
                    <span className="pr-5 pl-3 theme__font--medium">
                      {appPlatform.platformName}
                      <span className="pl-1 theme__font--medium">
                        ({appPlatform?.selectedPlatformCount})
                      </span>
                    </span>
                    <span className="pr-2 theme__font--medium">
                      <img src={showDropdown ? arrowup : arrowdown} alt="" />
                    </span>
                  </div>
                  {showDropdown && appCountData ? (
                    <ul>
                      {appCountData.map((app, index) => {
                        return (
                          <>
                            <span
                              className={`${styles.color_border} mlc-1 mtc-2`}
                              style={{
                                backgroundColor:
                                  app.color !== "#ffffff" ? app.color : "",
                              }}
                            />
                            <li
                              key={index}
                              className={`${
                                appPlatform.platformName === app.name
                                  ? "text-white"
                                  : ""
                              } d-justify-sb d-flex pt-1 pl-3`}
                              onClick={() => {
                                setAppPlatform({
                                  ...appPlatform,
                                  selectedPlatformCount: app.count,
                                  platformType: app.platform,
                                  platformName: app.name,
                                  platformColor: app.color,
                                });
                                setShowDropdown(false);
                              }}
                            >
                              <span className="theme__font--medium">
                                {app.name}
                              </span>
                              <span className="pr-3 theme__font--medium">
                                {app.count}
                              </span>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  ) : null}
                </div>
              </div>
              <div className={styles.osHeading}>
                {configData?.osList?.map(
                  (el) =>
                    el.show && (
                      <button
                        style={{
                          width: "20%",
                          height: "65px",
                          background: "#1A1A1A",
                          border:
                            currentOs === el.id ? "1px solid white" : "none",
                          borderRadius: "10px",
                          color: "white",
                          fontFamily: "JioType-Medium",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={() => setCurrentOs(el.id)}
                      >
                        <img src={el?.icon} alt={el.id} />
                        {el?.value}
                      </button>
                    )
                )}
              </div>
              {apps && (
                <div className={styles.panelcontainer}>
                  <h4>Apps</h4>
                  <div className={styles.panel}>
                    <div
                      className={styles.appcreate}
                      onClick={() => openAppModal()}
                    >
                      <img
                        src={plus}
                        alt="logo"
                        className=""
                        style={{
                          width: "1rem",
                          height: "1rem",
                          marginLeft: "0.25rem",
                          marginBottom: "0.25em",
                        }}
                      />
                      Create New App
                    </div>
                    {apps.map((app) => (
                      <div
                        key={app.id}
                        // onClick={() => handleCardClick(project.id, project.status)}
                      >
                        <AppCard app={app} key={app.id} />
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div className={`${styles.keycontainer} d-hide `}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "-0.6em",
                  }}
                >
                  <h4>Project key</h4>

                  <Tooltip title="This is the unique project key" arrow>
                    <p>
                      <img
                        className={styles.projectkeytooltip}
                        data-class="myTooltipClass"
                        src={info}
                        alt="category-icon"
                      />
                    </p>
                  </Tooltip>
                </div>
                <div className={`${styles.key}`}>
                  <span>{projectKey}</span>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(projectKey);
                      CustomToast(
                        "Your project Key has been Copied to clipboard"
                      );
                    }}
                    className=""
                  >
                    Copy key
                  </button>
                </div>
              </div>
              <span className="d-hide theme__font--medium font-size-12 ">
                <img
                  src={info}
                  alt="info-icon"
                  style={{
                    marginBottom: "0.2em",
                    marginRight: "0.4em",
                    opacity: "0.5",
                  }}
                />
                Copy this key and add it to your SDK Config window in your Unity
                Project
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Project;
